import type { ModelLeadsSearchFilter } from '@app/api/Leads/types';
import { formatDayjsToString } from '@app/utils/formatDayjsToString';

import { LEADS_REGISTRY_SEARCH_MIN_LENGTH } from '../constants';

import { mapTagsFilterToInt32ItemsFilters } from './mapTagsFilterToInt32ItemsFilters';

import type { LeadsRegistryFilters } from '../types';

export type LeadsRegistrySearchFilterBody = Omit<
  ModelLeadsSearchFilter,
  'MaxItems'
>;

// Builds the filter-derived part of the `SearchLeads` request from the
// Leads registry filter model. Pagination `MaxItems` is composed separately
// by the search hook.
export const buildLeadsRegistrySearchFilter = (
  filters: LeadsRegistryFilters
): LeadsRegistrySearchFilterBody => {
  const trimmedSearch = filters.search.trim();
  const minLength = LEADS_REGISTRY_SEARCH_MIN_LENGTH[filters.searchType];
  const searchTerm = trimmedSearch.length >= minLength ? trimmedSearch : null;

  const dateStart = formatDayjsToString(filters.dates[0]);
  const dateEnd = formatDayjsToString(filters.dates[1]);
  const isCreatedPeriod = filters.periodType === 'created';
  const isActivityPeriod = filters.periodType === 'activity';

  return {
    SearchTerm: searchTerm,
    SearchTermIn: filters.searchType,
    DateCreateS: isCreatedPeriod ? dateStart : null,
    DateCreateE: isCreatedPeriod ? dateEnd : null,
    DateActiveS: isActivityPeriod ? dateStart : null,
    DateActiveE: isActivityPeriod ? dateEnd : null,
    UserIds: filters.users.map(Number),
    IntegrationIds: filters.integrations.map(Number),
    StatusIds: filters.statuses,
    CrmTaskStatusIds: filters.crmTaskStatuses,
    ChannelIds: filters.channels,
    BranchIds: filters.branches.map(Number),
    TagFilters: mapTagsFilterToInt32ItemsFilters(filters.tags),
    SalesFunnelsStages: filters.funnelStages,
  };
};
